/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The MetricParamsSport model module.
 * @module model/MetricParamsSport
 * @version 0.0.2
 */
export class MetricParamsSport {
  /**
   * Constructs a new <code>MetricParamsSport</code>.
   * @alias module:model/MetricParamsSport
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>MetricParamsSport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MetricParamsSport} obj Optional instance to populate.
   * @return {module:model/MetricParamsSport} The populated <code>MetricParamsSport</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MetricParamsSport();
      if (data.hasOwnProperty('stepsPerKm'))
        obj.stepsPerKm = ApiClient.convertToType(data['stepsPerKm'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} stepsPerKm
 */
MetricParamsSport.prototype.stepsPerKm = undefined;

